export const cleaningQuantityStep = (item, fallback = 1) => {
  const name = String(item?.order_products_name || item?.product_name || item?.product_title || item?.name || '').toLowerCase();
  return name.includes('cleaning') || item?.category_id === 'cleaning'
    ? 0.5
    : fallback;
};
